import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const DropZone = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  border: 2px dashed ${(props) => 
    props.$isDragActive 
      ? props.theme.colors?.primary || "#3B82F6"
      : props.theme.colors?.border || "#E5E7EB"
  };
  border-radius: 12px;
  background: ${(props) => 
    props.$isDragActive 
      ? props.theme.colors?.primaryLight || "#EFF6FF"
      : props.theme.colors?.backgroundSecondary || "#F9FAFB"
  };
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
    background: ${(props) => props.theme.colors?.primaryLight || "#EFF6FF"};
  }

  input {
    display: none;
  }
`;

export const DropZoneIcon = styled.div`
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  border-radius: 16px;
  background: ${(props) => props.theme.colors?.background || "#FFFFFF"};
  color: ${(props) => props.theme.colors?.primary || "#3B82F6"};

  svg {
    width: 32px;
    height: 32px;
  }
`;

export const DropZoneText = styled.p`
  font-size: 16px;
  color: ${(props) => props.theme.colors?.text || "#111827"};
  margin: 0 0 8px 0;
  text-align: center;

  span {
    color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
    font-weight: 600;
    cursor: pointer;
  }
`;

export const DropZoneHint = styled.p`
  font-size: 14px;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
  margin: 0;
`;

export const FileInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid ${(props) => props.theme.colors?.border || "#E5E7EB"};
  border-radius: 8px;
  background: ${(props) => props.theme.colors?.background || "#FFFFFF"};
`;

export const FileDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const FileIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: ${(props) => props.theme.colors?.successLight || "#D1FAE5"};
  color: ${(props) => props.theme.colors?.success || "#059669"};

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const FileText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const FileName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.colors?.text || "#111827"};
`;

export const FileSize = styled.span`
  font-size: 12px;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
`;

export const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: ${(props) => props.theme.colors?.textSecondary || "#6B7280"};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) => props.theme.colors?.backgroundSecondary || "#F3F4F6"};
    color: ${(props) => props.theme.colors?.error || "#DC2626"};
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ContactCount = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors?.primaryLight || "#EFF6FF"};
  color: ${(props) => props.theme.colors?.primary || "#3B82F6"};
  font-size: 14px;
  font-weight: 500;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const ErrorMessage = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 8px;
  background: ${(props) => props.theme.colors?.errorLight || "#FEE2E2"};
  color: ${(props) => props.theme.colors?.error || "#DC2626"};
  font-size: 14px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const LoadingOverlay = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
`;
